export default __webpack_public_path__ + "static/sprinkle-pattern-b9c291f5de183851d7089b9d249ab978.svg";